"use client";

import React from "react";
import { User } from "@/api/users/types";
import { useQueryClient, useMutation, useQueries } from "@tanstack/react-query";
import commentsApi from "@/api/comments/nft/client";
import nftsApi from "@/api/nfts/client";
import { CommentInput } from "../../Input";
import { NftCommentsTree } from "../../CommentsTree/NftCommentsTree";

export interface Props {
  nftId: string;
}
export default function NftCommentsList({ nftId }: Props) {
  const queryClient = useQueryClient();

  const user: User | undefined = queryClient.getQueryData(["me"]);

  const [{ data: comments }, { data: nft }] = useQueries({
    queries: [
      {
        queryKey: ["nft-comments", nftId],
        queryFn: async () => await commentsApi.getNftComments(nftId),
      },
      {
        queryKey: ["nft", nftId],
        queryFn: async () => await nftsApi.getSingleNft(nftId),
      },
    ],
  });

  const { mutateAsync: postNftComment } = useMutation({
    mutationFn: (value: string) =>
      commentsApi.postNftComment({
        text: value,
        repliedToNftId: nftId,
        authorId: user?.id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["nft-comments", nftId]);
    },
  });

  return (
    <>
      <CommentInput
        onCommentPost={async (comment: string) => await postNftComment(comment)}
      />
      {comments?.length
        ? comments.map((comment) => (
            <NftCommentsTree
              key={comment.id}
              nft={nft}
              comment={comment}
              depth={1}
            />
          ))
        : null}
    </>
  );
}
